module.exports = __webpack_public_path__ + "img/print_fingerprint@2x.770f3a2.jpg";